import { supabase } from "@/integrations/supabase/client";

export async function getCurrentClinicId(): Promise<string> {
  const { data, error } = await supabase.rpc("get_current_user_clinic_id");

  if (error) throw error;
  if (!data) throw new Error("Nenhuma clínica selecionada");

  return data;
}

/**
 * Gets the customer_id of the current clinic the user is viewing.
 * This is essential for multi-tenancy to ensure invited users see data
 * from the clinic's customer, not their own profile's customer.
 * 
 * @returns The customer_id of the current clinic
 * @throws Error if user is not authenticated, has no current clinic, or clinic not found
 */
export async function getCurrentClinicCustomerId(): Promise<string> {
  const { data, error } = await supabase.rpc("get_current_customer_id");

  if (error) throw error;
  if (!data) throw new Error("Customer da clínica não encontrado");

  return data;
}
